/**
 * View component for /files/new
 *
 * Creates a new file from a copy of the defaultItem in the file reducer
 */

// import primary libraries
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import withRouter from 'react-router-dom/withRouter'

// import third-party libraries
import _update from 'lodash/update'
import _cloneDeep from 'lodash/cloneDeep'

// import actions
import * as clientActions from '../../clientActions.js'

// import global components
import Binder from '../../../../global/components/Binder.jsx'
import Modal from '../../../../global/components/modals/Modal.jsx'
import FileInput from '../../../../global/components/forms/FileInput.jsx'
import CheckboxInput from '../../../../global/components/forms/CheckboxInput.jsx'
import SelectFromArray from '../../../../global/components/forms/SelectFromArray.jsx'
import TextInput from '../../../../global/components/forms/TextInput.jsx'

// import resouce components
import ClientNotificationForm from '../../../notification/components/ClientNotificationForm.jsx'

class ClientNotificationToggleForm extends Binder {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
      clientNotification: {
        sN_upload: true,
        sN_viewed: true,
        sN_downloaded: true,
        sN_leaveComment: true,
        sN_sendMessage: true,
        sN_autoSignatureReminder: true,
        sN_requestTasks: true,
      },
    }
    this._bind('_handleClose', '_handleSubmit', '_handleFormChange')
  }

  _handleFormChange(name, value) {
    let newState = _update(this.state, name, () => {
      return value
    })
    this.setState({ newState, message: '' })
  }

  _handleSubmit(e) {
    const { dispatch, selectedClientId, match } = this.props
    const clientNotification = _cloneDeep(this.state.clientNotification)
    const sendData = {
      clientIds: selectedClientId,
      firmId: match.params.firmId,
      sN_upload: clientNotification.sN_upload,
      sN_viewed: clientNotification.sN_viewed,
      sN_downloaded: clientNotification.sN_downloaded,
      sN_leaveComment: clientNotification.sN_leaveComment,
      sN_sendMessage: clientNotification.sN_sendMessage,
      sN_autoSignatureReminder: clientNotification.sN_autoSignatureReminder,
      sN_requestTasks: clientNotification.sN_requestTasks,
    }

    this.setState({ submitting: true })
    dispatch(clientActions.sendBulkNotificationUpdate(sendData)).then(json => {
      if (json.success) {
        this._handleClose('success')
      } else {
        alert(json.message)
        this.setState({ submitting: false })
      }
    })
  }

  _handleClose(type) {
    const { close, handleClose } = this.props
    this.setState(
      {
        submitting: false,
        clientNotification: {
          sN_upload: true,
          sN_viewed: true,
          sN_downloaded: true,
          sN_leaveComment: true,
          sN_sendMessage: true,
          sN_autoSignatureReminder: true,
          sN_requestTasks: true,
        },
      },
      () => {
        if (type === 'success' && handleClose) {
          handleClose()
        } else if (close) {
          close()
        }
      },
    )
  }

  render() {
    const { isOpen, selectedClientId } = this.props

    const { submitting, clientNotification } = this.state

    const isStaffOwner = true
    console.log('selectedClientId', selectedClientId)
    return (
      <Modal
        closeAction={this._handleClose}
        closeText="Cancel"
        confirmAction={this._handleSubmit}
        confirmText={submitting ? 'Saving...' : 'Save'}
        disableConfirm={submitting}
        isOpen={isOpen}
        modalHeader="Clients Notification Settings"
      >
        <div>
          <div className="-share-link-configuration">
            <div className="-body">
              <ClientNotificationForm
                handleFormChange={this._handleFormChange}
                clientNotification={clientNotification}
                allowedToUpdate={true}
              />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

ClientNotificationToggleForm.propTypes = {
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
}

ClientNotificationToggleForm.defaultProps = {}

const mapStoreToProps = store => {
  /**
   * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
   * differentiated from the React component's internal state
   */
  return {
    loggedInUser: store.user.loggedIn.user,
  }
}

export default withRouter(
  connect(mapStoreToProps)(ClientNotificationToggleForm),
)
